import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'
import { darkBlue, secondaryB } from 'asterX-UIkit/constants/colors'
import { useTranslation } from 'react-i18next'
import { serviceList, statusList, systemList, typeList } from 'lib/constants'
import { accesses } from 'lib/utils'
import {
  Collapse,
  Grid,
  IconButton,
  Paper,
  Typography,
  MenuItem
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { KeyboardDatePicker } from '@material-ui/pickers'
import AsterTextField from 'asterX-UIkit/Inputs/AsterTextField'
import AsterSelect from 'asterX-UIkit/Inputs/AsterSelect'
import AsterButton from 'asterX-UIkit/Buttons/AsterButton'
import AsterCheckbox from 'asterX-UIkit/Inputs/AsterCheckbox'
import CloseIcon from '@material-ui/icons/Close'
import { ASTERX_DIVISION, HELP_DESK_DIVISION } from 'constants/divisions'
import { RootStoreContext } from 'store/rootStore'
import jwtDecode from 'jwt-decode'

const useStyles = makeStyles(() => ({
  rootPaper: {
    flexGrow: 0,
    padding: '12px 24px 10px 24px',
    backgroundColor: secondaryB,
    borderRadius: 9,
    boxShadow: 'none'
  },
  title: {
    color: darkBlue,
    fontWeight: 700,
    fontSize: 14
  }
}))

const Filter = ({
  loading,
  filter: { filter, setFilter },
  onReset,
  onSearch,
  selectedTab
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [showFilter, setShowFilter] = useState(false)

  const { authStore, usersAdmin } = useContext(RootStoreContext)
  const token = jwtDecode(authStore.user.token)
  const admin = (usersAdmin.userList || [])?.find(
    item => item?.username === token.sub
  )
  const isAdmin = true
  const adminID = accesses(['ADMIN'])

  const handleChange = name => val => {
    const value = val.hasOwnProperty('target')
      ? val.target.value
      : moment(val).format('YYYY-MM-DD')
    setFilter(prevState => ({ ...prevState, [name]: value }))
  }

  const handleToggle = name => (_e, checked) => {
    setFilter(prev => ({ ...prev, [name]: checked ? checked : null }))
  }

  const handleChangeStatus = e => {
    const value = e.target.value
    authStore.setStatus(statusList.find(f => f.id === Number(value?.id)))
  }

  const handleShowFilter = () => setShowFilter(!showFilter)

  useEffect(() => {
    if (selectedTab === 4 && isAdmin) {
      setFilter(prevState => ({
        ...prevState,
        adminUsername: admin.username
      }))
    }
  }, [selectedTab, isAdmin])

  useEffect(() => {
    if (
      selectedTab === 4 &&
      isAdmin &&
      filter.adminUsername === admin?.username
    ) {
      onSearch()
    }
  }, [filter, admin])

  return (
    <Paper className={classes.rootPaper}>
      <Grid
        container
        direction={'row'}
        justify={'flex-start'}
        alignItems={'center'}
      >
        <Grid item xs={10} md={10}>
          <Typography className={classes.title}>
            {t('home.filterLog.title')}
          </Typography>
        </Grid>
        <Grid item container justify={'flex-end'} xs={2} md={2}>
          <IconButton onClick={handleShowFilter} style={{ color: darkBlue }}>
            {showFilter ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>
      </Grid>
      <Collapse in={showFilter}>
        <Grid
          container
          direction={'row'}
          justify={'center'}
          alignItems={'center'}
          spacing={2}
        >
          <Grid item xs={3} md={3}>
            <AsterTextField
              fullWidth
              label="Номер заявки"
              value={filter.id || ''}
              onChange={handleChange('id')}
            />
          </Grid>
          <Grid item xs={3} md={3}>
            <KeyboardDatePicker
              fullWidth
              name={'createdDateFrom'}
              label="Дата с"
              value={
                filter.createdDateFrom
                  ? moment(filter.createdDateFrom).format()
                  : null
              }
              format="dd.MM.yyyy"
              onChange={handleChange('createdDateFrom')}
              TextFieldComponent={AsterTextField}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </Grid>

          <Grid item xs={3} md={3}>
            <KeyboardDatePicker
              name="createdDateTo"
              fullWidth
              label="Дата до"
              value={
                filter.createdDateTo
                  ? moment(filter.createdDateTo).format()
                  : null
              }
              onChange={handleChange('createdDateTo')}
              format="dd.MM.yyyy"
              TextFieldComponent={AsterTextField}
              KeyboardButtonProps={{
                'aria-label': 'change date'
              }}
            />
          </Grid>


          {adminID ? (
            <>
              <Grid item xs={3} md={3}>
                <AsterSelect
                  name="status"
                  label="Статус заявки"
                  fullWidth
                  value={
                    !!authStore.statusId && selectedTab !== 4
                      ? statusList.find(f => f.id === authStore.statusId)
                      : statusList[0]
                  }
                  onChange={e => handleChangeStatus(e)}
                >
                  {statusList.filter(Boolean).map(status => (
                    <MenuItem key={status.id} value={status}>
                      {status.label}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>
              <Grid item xs={3} md={3}>
                <AsterSelect
                  label="Модуль"
                  fullWidth
                  value={filter.module || ''}
                  onChange={handleChange('module')}
                >
                  <MenuItem value="">Не выбрано</MenuItem>
                  {systemList.filter(Boolean).map(module => (
                    <MenuItem key={module.id} value={module.id}>
                      {module.name}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>

              <Grid item xs={3} md={3}>
                <AsterSelect
                  fullWidth
                  label="Ответственный"
                  value={filter.adminUsername || ''}
                  onChange={handleChange('adminUsername')}
                >
                  <MenuItem value="">Не выбрано</MenuItem>

                  {usersAdmin?.userList?.map(admin => (
                    <MenuItem key={admin.username} value={admin.username}>
                      {`${admin.firstName} ${admin.lastName}`}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>

              <Grid item xs={3} md={3}>
                <AsterTextField
                  fullWidth
                  name="createdByFullname"
                  label="Инициатор заявки"
                  value={filter.createdByFullname || ''}
                  onChange={handleChange('createdByFullname')}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={3} md={3}>
                <AsterSelect
                  label="Отдел"
                  fullWidth
                  value={filter.department || ''}
                  onChange={handleChange('department')}
                >
                  <MenuItem>Все отделы</MenuItem>
                  {[ASTERX_DIVISION, HELP_DESK_DIVISION].map(department => (
                    <MenuItem key={department} value={department}>
                      {department}
                    </MenuItem>
                  ))}
                </AsterSelect>
              </Grid>
            </>
          )}

          <Grid item xs={3} md={3} >
            <AsterCheckbox
              name="hadQuestionnaire"
              color="primary"
              label="Имел анкету"
              checked={!!filter.hadQuestionnaire}
              onChange={handleToggle('hadQuestionnaire')}
            />
          </Grid>

          <Grid
            item
            container
            direction={'row'}
            justify={'space-between'}
            alignItems={'center'}
            xs={12}
            md={12}
            spacing={2}
          >
            <Grid item xs={6} md={4}>
              <AsterButton
                fullWidth
                color={'secondary'}
                disabled={loading}
                onClick={onReset}
              >
                <CloseIcon />
                {t('home.filterLog.clear')}
              </AsterButton>
            </Grid>
            <Grid item xs={6} md={4}>
              <AsterButton
                color={'primary'}
                fullWidth
                disabled={loading}
                onClick={onSearch}
              >
                {t('home.filterLog.search')}
              </AsterButton>
            </Grid>
          </Grid>
        </Grid>
      </Collapse>
    </Paper>
  )
}

export { Filter }
